// src/redux/slices/Bank/SavingSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = "https://payyug.in/api"; // admin API base

// Async thunk to fetch schemes
export const fetchSavingSchemes = createAsyncThunk(
  'saving/fetchSavingSchemes',
  async (_, { rejectWithValue }) => {
    try {
      console.log("Calling API...");
      const response = await axios.get('/api/saving-schemes'); // <- check URL
      console.log("API Response:", response.data);
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data);
    }
  }
);


const initialState = {
  schemes: [],
  loading: false,
  error: null,
};

const savingSlice = createSlice({
  name: 'saving',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavingSchemes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavingSchemes.fulfilled, (state, action) => {
        state.loading = false;
        state.schemes = action.payload;
      })
      .addCase(fetchSavingSchemes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default savingSlice.reducer;
